import type { FC } from 'react';
import { MobileStepperProps } from '@mui/material';

import { StyledMobileStepper } from './styles';

interface IMplStepperProps extends Partial<MobileStepperProps> {
	steps: number;
	activeStep: number;
}

export const MplStepper: FC<IMplStepperProps> = ({
	steps,
	backButton,
	nextButton,
	...otherProps
}) => (
	<StyledMobileStepper
		steps={steps}
		variant="dots"
		position="static"
		backButton={backButton}
		nextButton={nextButton}
		{...otherProps}
	/>
);
